import { type SecondaryCategoryConstructor } from '@webapp/core/entities/internal/SecondaryCategory'
import { mapLegalEntitySummary } from './mapLegalEntitySummary'
import { mapLocation } from './mapLocation'
import { type DepartmentApiModel } from '../api-models/DepartmentApiModel'

export const mapDepartment = (
  dept: Pick<
    DepartmentApiModel,
    'id' | 'name' | 'branch' | 'location' | 'legal_entity'
  >
): SecondaryCategoryConstructor => {
  const branch = dept.branch ?? dept.location ?? null

  return {
    id: dept.id,
    name: dept.name,
    primaryCategory: branch ? mapLocation(branch) : null,
    ...(dept.legal_entity
      ? { legalEntity: mapLegalEntitySummary(dept.legal_entity) }
      : {}),
  }
}
